import _ from "lodash";
import axios from "axios";

import { sisi_api_url, website_api_key } from "../api";
import { trainsErrorMsgs } from "../errors";

// ======================= SEARCH TRAINS ========================
export const searchRequestTrains = async ({ payload, onFailed }) => {
  try {
    const response = await axios.post(`${sisi_api_url}/railengine/search/`, {
      ...payload,
      website_api_key,
    });
    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
    onFailed(
      _.get(
        error,
        "response.data.message.message",
        trainsErrorMsgs.searchForm.init_search
      )
    );
  }
  return null;
};

// ======================= SEARCH TRAINS ========================
export const getSavedSessionRequestTrains = async ({ search_session_id }) => {
  try {
    const response = await axios.get(
      `${sisi_api_url}/railengine/search/${search_session_id}`
    );
    return response?.data ?? {};
  } catch (error) {
    console.error(error);
  }
  return null;
};

// ======================= PRE-BOOK ========================
export const trainPrebook = async ({ payload, onFailed }) => {
  try {
    const response = await axios.post(`${sisi_api_url}/railengine/prebook`, {
      ...payload,
    });
    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
    onFailed(
      _.get(
        error,
        "response.data.message",
        trainsErrorMsgs.searchForm.init_search
      )
    );
  }
  return null;
};

// ========================= BOOK =========================
export const trainBook = async ({ payload, onError }) => {
  try {
    const response = await axios.post(
      `${sisi_api_url}/railengine/book`,
      payload
    );
    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
    onError(
      _.get(
        error,
        "response.data.message",
        trainsErrorMsgs.general.unexpectedError
      )
    );
  }
  return null;
};

// ========================= BOOK =========================
export const trainBookCRS = async (payload) => {
  try {
    const response = await axios.post(
      `${sisi_api_url}/railengine/book-crs/`,
      payload
    );
    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
  }
  return null;
};

// ==================== GET OPERATOR ICON ========================
export const getCarrierIcon = async (carrier) => {
  try {
    const response = await axios.get(
      `https://era.raileurope.com/assets/images/operating-carriers/${carrier}.svg`
    );
    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
  }
  return null;
};
